<template>
    <div class="modal fade"id="addUpdateCouponModal" tabindex="-1" data-backdrop="static"role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Add / Update Coupon: {{coupon.couponCode}}</h4>
                </div>
                <form method="post" @submit.prevent="updateCoupon()">
                    <div class="modal-body">
                        <div v-if="!baykedCustomerCoupon">
                            <div class="form-group">
                              <label>Select Restaurant</label>
                              <multiselect v-model="selectedRestaurant" :disabled="isBranchCoupon" id="restaurant" :options="restaurants" :allow-empty="false" label="name" track-by="name"></multiselect>
                            </div>
                        </div>
                        <div v-else>
                          <div class="form-group">
                            <label>Select Customer</label>
                            <multiselect v-model="selectedCustomer" id="customer" :options="customers" :allow-empty="false" label="name" track-by="name"></multiselect>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                            <label>Select Type</label>
                            <div class="form-group">
                                <label class="radio-inline"><input type="radio" :disabled="isBranchCoupon" name="typeradio" :value="true" v-model="coupon.oneTime" checked>One Time</label>
                                <label class="radio-inline"><input type="radio" :disabled="isBranchCoupon" name="typeradio" :value="false" v-model="coupon.oneTime">Multiple</label>
                            </div>
                            </div>
                            <div class="col-md-6">
                            <label>Discount Type</label>
                        <div class="form-group">
                            <label class="radio-inline"><input type="radio" :disabled="isBranchCoupon" name="optradio" :value="true" v-model="coupon.inPercentage" checked>In Percentage</label>
                            <label class="radio-inline"><input type="radio" :disabled="isBranchCoupon" name="optradio" :value="false" v-model="coupon.inPercentage">Flat Price</label>
                        </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="coupon.oneTime">
                            <label for="name">Coupon code</label>
                        <input :value="coupon.couponCode.toUpperCase()" @input="coupon.couponCode = $event.target.value.toUpperCase()" type="text" required="required" class="form-control" id="name" placeholder="Prefix...">
                        </div>
                        <div class="row" v-if="coupon.oneTime">
                            <div class="col-md-3">
                            <input v-model="coupon.couponCode" type="text" readonly class="form-control" placeholder="Prefix-Start">
                            </div>
                            <div class="col-md-3">
                                <input v-model="fromCode" type="number" required="required" class="form-control" placeholder="from">
                            </div>
<!--                            <div class="col-md-2 m-t-lg" style="padding: 0; width: 10px"><p><b>&#45;&#45;</b></p></div>-->
                            <div class="col-md-3">
                                <input v-model="coupon.couponCode" type="text" readonly class="form-control" placeholder="Prefix-End">
                            </div>
                            <div class="col-md-3">
                                <input v-model="toCode" type="number" required="required" class="form-control" placeholder="to">
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-md-12">
                                <label for="name">Coupon Code</label>
                                <input :value="coupon.couponCode.toUpperCase()" @input="coupon.couponCode = $event.target.value.toUpperCase()" type="text" required="required" class="form-control" placeholder="Code...">
                            </div>
                        </div>
                        <br/>
                        <div class="form-group">
                            <label >Discount Amount</label>
                            <input v-model="coupon.discount" type="number" min="0" required="required" class="form-control" placeholder="Discount...">
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                        <div class="form-group">
                            <label >Start Date</label>
                            <input v-model="coupon.startDate" :min="new Date().toISOString().split('T')[0]" type="date" required="required" class="form-control" placeholder="Start Date...">
                        </div>
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">
                            <label>Expiry Date</label>
                            <input v-model="coupon.endDate" :min="DefaultExpireDate" required="required" type="date" class="form-control" placeholder="Expire Date...">
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                    <div class="sk-bounce1"></div>
                                    <div class="sk-bounce2"></div>
                                    <div class="sk-bounce3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" @click="closeModal()">Close</button>
                        <button type="submit" class="btn btn-primary" @click="closeModal()">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
/* eslint-disable */
import Multiselect from 'vue-multiselect'
import {getBaykedCustomerDetails} from "../../api/customers";

export default {
        components: { Multiselect },
        name: "AddUpdateCoupon",
        data:function() {
            return {
                coupon: {
                    "id": 0,
                    "startDate": null,
                    "endDate": null,
                    "couponCode": "",
                    "discount": null,
                    "inPercentage": true,
                    "oneTime": true,
                    "restaurantsByRestaurantId": null,
                    "dvmCustomers": null,
                    "redeemed": false
                },
                customers: [],
                selectedCustomer: "",
                selectedRestaurant:null,
                loggedInRole:"",
                isHideSpinner: "hide",
                restaurants:[],
                fromCode: null,
                toCode: null,
                code: null,
                queryParameter: null,
                baykedCustomerCoupon: false,
                isBranchCoupon: false,
            };
        },
      computed: {
        DefaultExpireDate() {
          if (this.coupon.startDate) {
            const otherDay = new Date(this.coupon.startDate)
            otherDay.setDate(otherDay.getDate() + 1);
            return moment(otherDay).format("YYYY-MM-DD");
          }
        }
      },
        props: ["where"],
        mounted: async function () {
          let user = this.$store.state.user;
          this.loggedInRole = this.$store.state.user;
          let role = user.userRolesById[0].role;
          if (role === 'ROLE_ADMIN') {
            console.log("in admin");
            this.queryParameter = this.$route.query;
            if (this.queryParameter.res !== undefined) {
              this.isBranchCoupon = true
              this.coupon.oneTime = false
              this.coupon.inPercentage = true
              await this.loadRestaurantDetails(this.queryParameter.res);
              console.log("Selected Restaurant: " , this.selectedRestaurant);
              this.loadRestaurants()
            }else if(this.queryParameter.customerId !== undefined){
              await this.loadCustomerDetails(this.queryParameter.customerId);
              this.customers.push(this.selectedCustomer);
              this.baykedCustomerCoupon = true;
            }else{
              this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                this.restaurants = resp.data;
              });
            }

          } else if (role === 'ROLE_USER') {
            this.selectedRestaurant = this.$store.state.user.restaurant;
            this.restaurants.push({
              id: this.$store.state.user.restaurant.id,
              name: this.$store.state.user.restaurant.name
            });
          }
          console.log(this.where);
        },
        methods: {
            loadRestaurants() {
              this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                this.restaurants = resp.data;
              });
            },
            load: function () {
                this.resetData()
                this.queryParameter = this.$route.query;
                if(!this.queryParameter.res) {
                  this.isBranchCoupon = false
                }
                $("#addUpdateCouponModal").modal("show");
            },
            loadModal: function (){
              let riderModal = $("#addUpdateCouponModal");
              setTimeout(() => {
                riderModal.modal("show");
                riderModal.focus();
              }, 500);
            },
            loadRestaurantDetails: async function (restaurantId) {
              let params = new URLSearchParams();
              params.append("restaurant_id", restaurantId)
              let restaurantResp = await this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params).catch(ex => {
                this.showErrorMessage(ex);
              });
              this.selectedRestaurant = restaurantResp.data;
              this.loadModal();
            },
            loadCustomerDetails: async function (customerId) {
              let customerDetailsResp = await getBaykedCustomerDetails(customerId).catch(ex => {
                this.showErrorMessage(ex);
              });
              this.selectedCustomer = customerDetailsResp.data;
              this.loadModal();
            },
            updateCoupon: function () {
              this.coupon.restaurantsByRestaurantId = (this.selectedRestaurant) ? this.selectedRestaurant : null;
              this.coupon.dvmCustomers = (this.selectedCustomer) ? this.selectedCustomer : null;
              this.coupon.discount = parseInt(this.coupon.discount)
              if (!this.coupon.oneTime) {
                this.fromCode = 0
                this.toCode = 0
              } else {
                let couponCount = Math.abs(this.toCode - this.fromCode)
                if(couponCount > 50) {
                  swal("Error!", "Only 50 coupons can be created at a time. Please try again!", "error");
                  return
                }
              }
              if (!this.baykedCustomerCoupon && this.selectedRestaurant === "") {
                swal("Error!", "Restaurant is required. Please try again!", "error");
                return;
              }
              Swal.fire({
                title: 'Please Wait! We are processing the data.',
                type: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                onBeforeOpen: () => {
                  Swal.showLoading();
                },
              });
              let params = new URLSearchParams();
              params.append("coupon", JSON.stringify(this.coupon))
              params.append("fromCode", this.fromCode)
              params.append("toCode", this.toCode)
              this.$http.post(this.$store.state.mainAppURL + "restaurants/save_coupons", params).then(resp => {
                Swal.close();
                if (resp.data) {
                  $("#addUpdateCouponModal").modal("hide");
                  swal("SUCCESS!", "Coupon has been added successfully!", "success");
                  if (this.queryParameter.res !== undefined) {
                    this.$router.replace("/restaurants?res=" + this.queryParameter.res + "&br=" + this.queryParameter.br+"&coupId="+resp.data);
                  } else if(this.queryParameter.customerId !== undefined) {
                    this.$router.replace("/bayked_customers?customerId=" + this.selectedCustomer.id);
                  }else
                    this.$parent.tableDraw();
                  this.resetData();
                } else {
                  swal("Error!", "Please try again!", "error");
                }
              }).catch(ex => {
                swal("Error!", ex + "Please try again!!", "error");
              });
            },
            resetData: function () {
                this.coupon = {
                    "id": 0,
                    "startDate": null,
                    "endDate": null,
                    "couponCode": "",
                    "discount": null,
                    "inPercentage": true,
                    "oneTime": true,
                    "restaurantsByRestaurantId": null,
                    "redeemed": false
                };
                this.selectedRestaurant = "";
                this.fromCode = null
                this.toCode = null
                this.code = null
            },
            closeModal() {
              this.queryParameter = this.$route.query;
              if(!this.queryParameter.res) {
                if (this.$router.currentRoute.fullPath !== '/coupons') {
                  this.$router.push("/coupons");
                  this.loadRestaurants()
                } else {
                  this.selectedCustomer = null
                }
                  this.baykedCustomerCoupon = false
              }

            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
